import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "layout__wrapper" }
const _hoisted_2 = { class: "books-categories" }
const _hoisted_3 = { class: "docs-listing docs-listing--books" }

import { onBeforeMount, onMounted, ref } from 'vue'
import type { Raw } from 'vue'
import { useRouter } from 'vue-router'
import { useWait } from '@/app/composables/useWait'

import Layout from '@/app/components/Layout.vue'
import HeaderRoot from '@/app/components/header/Root.vue'
import CategoriesSelection from '@/app/components/listing/categories/CategoriesSelection.vue'
import ListDocs from '@/app/components/listing/ListDocs.vue'

import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'

import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'

import {
  BooksView,
  showReviewPrompt,
  trustpilotReviewPrompt,
} from '@/models/doc.book'
import LoadingError from '@/components/ui/LoadingError.vue'
import { DocsTagsView } from '@/models/docs.tags'
import { offline } from '@/services/offline'
import { loadBookListFromNativeStorage } from '@/services/native.storage'
import { ListView } from '@/models/docs.list'


export default /*@__PURE__*/_defineComponent({
  __name: 'Books',
  setup(__props) {

const router = useRouter()
const wait = useWait()

const booksView = ref<Raw<ListView> | null>(null)
const tagsView = ref<Raw<DocsTagsView> | null>(null)

onBeforeMount(async () => {
  await loadBooks()
})

onMounted(async () => {
  // Check if we need to show the App Review Prompt
  // The trigger is going back to Books from reading a book. (#2812)
  const queryFrom = router.currentRoute.value.query.from
  if (queryFrom === 'book.page') {
    await showReviewPrompt()
    await trustpilotReviewPrompt()
  }
})

async function loadBooks(): Promise<void> {
  wait.start('Loading Books')
  try {
    if (offline.isOffline) {
      await loadBookListFromNativeStorage()
    }

    const docsUserDataPromise = backend.getDocsUserData()
    const booksData = await backend.getBooksWithRecommendations()

    const books = await BooksView.createView(
      booksData,
      undefined, // Default docsUserData value
      undefined, // Default defaultSort value
      true, // Set showCtaBlock
      undefined, // Default showFreeAtTheTop
      booksData.tags,
    )

    booksView.value = new ListView('All Books', books)
    tagsView.value = new DocsTagsView(booksData.tags, 'books')

    wait.end('Loading Books')

    // We deliberately set the user data _after_ ending the loading screen
    // because the user data is not essential for this page.
    booksView.value.setUserData(docsUserDataPromise)
  } catch (error: any) {
    wait.start('Error Loading Books')
    Sentry.captureException(error)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_wait = _resolveComponent("v-wait")!

  return (_openBlock(), _createBlock(Layout, { class: "layout--basic" }, {
    default: _withCtx(() => [
      _createVNode(HeaderRoot, {
        title: "Books",
        hasDocSort: true
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_wait, { for: "Error Loading Books" }, {
          waiting: _withCtx(() => [
            _createVNode(LoadingError)
          ]),
          _: 1
        }),
        _createVNode(_component_v_wait, {
          class: "layout__wrapper-inner layout__wrapper-inner--small-gap container",
          for: "Loading Books"
        }, {
          waiting: _withCtx(() => [
            _createVNode(LoadingSpinner)
          ]),
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_2, [
              (tagsView.value?.hasTags)
                ? (_openBlock(), _createBlock(CategoriesSelection, {
                    key: 0,
                    view: tagsView.value
                  }, null, 8, ["view"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("section", _hoisted_3, [
              (booksView.value)
                ? (_openBlock(), _createBlock(ListDocs, {
                    key: 0,
                    view: booksView.value
                  }, null, 8, ["view"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})